module.exports = __webpack_public_path__ + "static/media/7.11751e17.jpg";